import { IdentificationType } from "@/apps/shared/buyback/core/domain/constants/IdentificationType";

export class CustomerIdentification {
  clientNationalIdentificationType: IdentificationType;
  clientNationalIdentification: string;
  clientNationalIdentificationDeliveryDate: string;
  clientNationalIdentificationAutorityDelivery: string;

  constructor(
    clientNationalIdentificationType: IdentificationType,
    clientNationalIdentification: string,
    clientNationalIdentificationDeliveryDate: string,
    clientNationalIdentificationAutorityDelivery: string
  ) {
    this.clientNationalIdentificationType = clientNationalIdentificationType;
    this.clientNationalIdentification = clientNationalIdentification;
    this.clientNationalIdentificationDeliveryDate = clientNationalIdentificationDeliveryDate;
    this.clientNationalIdentificationAutorityDelivery = clientNationalIdentificationAutorityDelivery;
  }
}
